module.exports = __webpack_public_path__ + "app/principal/principal-check-config-all-31ecqeXo.html";